import { useState } from "react";
import HoverGallery from "@components/Features/HoverGallery/HoverGallery";
import { DeleteCompareOffer } from "@features/compare/DeleteCompareOffer";
import { getCurrencySymbol } from "@shared/lib/utils";
import { LeftIcon } from "@shared/ui/Icon/ui/Common/LeftIcon";
import { RightIcon } from "@shared/ui/Icon/ui/Common/RightIcon";
import { MAX_PAGE_NUMBER, MIN_PAGE_NUMBER, NEXT_TEXT_LABEL, PREV_TEXT_LABEL } from "./constants";
import { StickyCardCompareProps } from "./types";
import classes from "./StickyCardCompare.module.scss";

export const StickyCardCompare = ({ offer, hideDeleteMode }: StickyCardCompareProps) => {
    const [currentPage, setCurrentPage] = useState(MIN_PAGE_NUMBER);
    const totalImages = offer.imagesList.filter((image) => image.small).length;
    const maxPages =
        totalImages < MIN_PAGE_NUMBER ? MIN_PAGE_NUMBER : Math.min(totalImages, MAX_PAGE_NUMBER);
    const formatPrice = `${offer.price.toLocaleString("ru-RU")} ${getCurrencySymbol(offer.sourceId)}`;

    const handlePrev = () => {
        setCurrentPage((prev) => (prev > 1 ? prev - 1 : MIN_PAGE_NUMBER));
    };

    const handleNext = () => {
        setCurrentPage((prev) => (prev < maxPages ? prev + 1 : maxPages));
    };

    return (
        <div className={classes["sticky-card"]}>
            <HoverGallery
                offer={offer}
                pics={offer.imagesList}
                className={classes["sticky-card__gallery"]}
                externalPage={currentPage}
            />
            {hideDeleteMode && (
                <DeleteCompareOffer
                    offerId={offer.id}
                    className={classes["sticky-card__delete"]}
                    classNameIcon={classes["sticky-card__delete-icon"]}
                />
            )}
            <div className={classes["sticky-card__info"]}>
                <span className={classes["sticky-card__price"]}>{formatPrice}</span>
                <span className={classes["sticky-card__title"]}>{offer.title}</span>
                <div className={classes["sticky-card__controls"]}>
                    <button
                        className={classes["sticky-card__arrow"]}
                        aria-label={PREV_TEXT_LABEL}
                        onClick={handlePrev}
                    >
                        <LeftIcon className={classes["sticky-card__arrow--color"]} />
                    </button>
                    <span className={classes["sticky-card__count"]}>
                        {currentPage} из {maxPages}
                    </span>
                    <button
                        className={classes["sticky-card__arrow"]}
                        aria-label={NEXT_TEXT_LABEL}
                        onClick={handleNext}
                    >
                        <RightIcon className={classes["sticky-card__arrow--color"]} />
                    </button>
                </div>
            </div>
        </div>
    );
};